import once from 'lodash-es/once';
const ApiPath = '/api/i18n/strings';
class LocalisationService {
    constructor() {
        /**
         * The locales collection.
         */
        this.locales = [];
        /**
         * Get locales, use cached request if available.
         */
        this.fetchLocales = once(async () => {
            const response = await fetch(ApiPath, {
                cache: 'no-cache',
                headers: {
                    Accept: 'application/json',
                },
            });
            if (!response.ok) {
                return [];
            }
            const data = await response.json();
            return data;
        });
    }
    /**
     * Get locales, use cached request if available.
     */
    async load() {
        if (this.locales?.length) {
            return this.locales;
        }
        try {
            this.locales = await this.fetchLocales();
            return this.locales;
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.warn(err);
            return [];
        }
    }
}
export default new LocalisationService();
